module.exports = __webpack_public_path__ + "static/aissa-avatar-1f74e171e398748b76e238f814ebd03c.png";